import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Stars.svg'

export const IconStars = IconSVG as IconComponent
